import { useCallback, useState } from 'react';

type DialogProps<T> = {
  open: boolean;
  loading: boolean;
  errors: string[];
  data?: T | null;
};

const useModalDialog = <T, DialogName extends PropertyKey>() => {
  const [dialog, setDialog] = useState<{
    [key in DialogName]?: DialogProps<T>;
  }>();

  const onUpdateDialogState = useCallback(
    (dialogName: DialogName, state: Partial<DialogProps<T>>) => {
      setDialog((prev) => ({
        ...prev,
        [dialogName]: {
          ...prev?.[dialogName],
          ...state,
        },
      }));
    },
    [],
  );

  return { dialog, onUpdateDialogState };
};

export default useModalDialog;
